import React, { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { Team } from '../../../../../../types/entity.types';

import Button from '../../../../../common/button/Button';
import TextInput from '../../../../../common/input/text-input/TextInput';
import Modal from '../../../../../common/modal/Modal';
import DeleteTeamConfirmationModal from '../delete-team-confirmation-modal/DeleteTeamConfirmationModal';

import '../team-modals.scss';

type Props = {
  show: boolean;
  close: () => void;
  team?: Team;
  updateTeam: (teamToSave: Team, close: () => void) => void;
  deleteTeam: (deleteTeam: () => void) => void;
};

const EditTeamModal = ({ show, close, team, updateTeam, deleteTeam }: Props) => {
  const [name, setName] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);

  const { teamExternalReference } = useParams();

  const navigate = useNavigate();

  useEffect(() => {
    if (team) {
      setName(team.name ?? '');
      return;
    }
  }, [show, team]);

  if (!show) return <Fragment />;

  const handleDeleteClick = () => {
    deleteTeam(() => {
      navigate(-1);
      setShowConfirmation(false);
      close();
    });
  };

  const handleSaveClick = () => {
    const teamToSave: Team = {
      teamName: name,
      teamExternalReference: teamExternalReference
    };

    updateTeam(teamToSave, close);
  };

  if (showConfirmation) {
    return (
      <DeleteTeamConfirmationModal
        show={showConfirmation}
        close={() => setShowConfirmation(false)}
        team={team}
        onDeleteClick={handleDeleteClick}
      />
    );
  }

  return (
    <Modal show={show}>
      <section className="team-modals">
        <h1 className="team-modals__header">Edit Team</h1>
        <div className="edit-team-modal__inputs">
          <TextInput
            label="Team Name:"
            name="name"
            value={name}
            onChange={({ target }) => setName(target.value)}
            autoFocus
          />
        </div>
        <div className="team-modals__button-container">
          <Button text="Cancel" onClick={close} />
          <Button text="Delete" onClick={() => setShowConfirmation(true)} />
          <Button text="Save" onClick={handleSaveClick} disabled={!name} />
        </div>
      </section>
    </Modal>
  );
};

export default EditTeamModal;
